import React, { Component } from 'react';
import { formatVietnameseDate, isValidDate, renderRank } from '@/utils/helpers';

class PrintOrthodonticExam extends Component {

    render() {
        const { customer, data } = this.props;

        const ban_khoan_cua_benh_nhan = data?.ban_khoan_cua_benh_nhan || '';
        const kich_thuoc_cung_rang = data?.kich_thuoc_cung_rang || '';
        const ham_tren_muc_do_chen_chuc = data?.ham_tren_muc_do_chen_chuc || '';
        const ham_duoi_muc_do_chen_chuc = data?.ham_duoi_muc_do_chen_chuc || '';
        const khe_thua_ham_tren = data?.khe_thua_ham_tren || [];
        const khe_thua_ham_duoi = data?.khe_thua_ham_duoi || [];
        const thua_thieu_rang = data?.thua_thieu_rang || [];
        const bat_thuong_rang_can_luu_y = data?.bat_thuong_rang_can_luu_y || '';
        const do_trum = data?.do_trum || '';
        const do_chia = data?.do_chia || '';
        const rang_3_trai = data?.rang_3_trai || [];
        const rang_6_trai = data?.rang_6_trai || [];
        const rang_3_phai = data?.rang_3_phai || [];
        const rang_6_phai = data?.rang_6_phai || [];
        const duong_cong_spee = data?.duong_cong_spee || '';
        const mat_phang_can = data?.mat_phang_can || '';
        const loai_mo_nha_chu = data?.loai_mo_nha_chu || '';
        const can_lech_chuc_nang = data?.can_lech_chuc_nang || '';
        const khop_can_bat_thuong_can_luu_y = data?.khop_can_bat_thuong_can_luu_y || '';
        const kich_thuoc_luoi = data?.kich_thuoc_luoi || '';
        const tat_day_luoi = data?.tat_day_luoi || '';
        const quan_sat_va_luu_y_khac_chinh_nha = data?.quan_sat_va_luu_y_khac_chinh_nha || '';
        const dang_mat_thang = data?.dang_mat_thang || '';
        const do_can_doi_cam = data?.do_can_doi_cam || '';
        const tuong_quan_tang_mat_duoi = data?.tuong_quan_tang_mat_duoi || '';
        const moi_khep_nghi = data?.moi_khep_nghi || '';
        const ranh_moi_cam = data?.ranh_moi_cam || '';
        const bat_thuong_mat_thang_nghi = data?.bat_thuong_mat_thang_nghi || '';
        const duong_cuoi = data?.duong_cuoi || '';
        const cuoi_lo_nuou = data?.cuoi_lo_nuou || '';
        const hanh_lang_ma = data?.hanh_lang_ma || '';
        const duong_giua = data?.duong_giua || '';
        const bat_thuong_mat_thang_cuoi = data?.bat_thuong_mat_thang_cuoi || '';
        const dang_mat_nghieng = data?.dang_mat_nghieng || '';
        const goc_moi_tren = data?.goc_moi_tren || '';
        const vi_tri_cam = data?.vi_tri_cam || '';
        const goc_mat_phang_ham_duoi = data?.goc_mat_phang_ham_duoi || '';
        const lom_moi_cam = data?.lom_moi_cam || '';
        const hinh_thai_moi = data?.hinh_thai_moi || '';
        const huong_dieu_tri_so_bo = data?.huong_dieu_tri_so_bo || '';
        const created_at = data?.created_at || '';
        const doctor = data?.doctor?.full_name || '';

        const addressParts = [
            customer?.address?.trim(),
            customer?.hamlet?.trim(),
            customer?.wards_name?.trim(),
            customer?.province_name?.trim(),
        ];

        // Lọc bỏ phần rỗng hoặc undefined, rồi nối bằng dấu phẩy
        const address = addressParts.filter(Boolean).join(', ') || '-';

        return (
            <div className="container print-content">

                <div className="header">
                    <div className="logo-box">
                        <img src="https://chingodental.vn/Logo-fanpage-2.png" alt="Logo Chingo Dental" />
                    </div>

                    <div className="footer">
                        <div className="qr-box">
                            <img src="https://chingodental.vn/QRCode.jpg" alt="QR Code" />
                        </div>

                        <div className="clinic">
                            <div className="section-title">NHA KHOA CHINGO</div>
                            <span>CS1: Số 560 Nguyễn Văn Cừ, Phường Bồ Đề, TP. Hà Nội</span>
                            <span>Hotline: 0978 009 780</span>
                            <span>CS2: Số 22 Lê Hồng Phong, Phường Hải Châu, TP. Đà Nẵng</span>
                            <span>Hotline: 0916 019 696</span>
                            <span>CS3: Số 17 Lý Nam Đế, Phường Hội An, TP. Đà Nẵng</span>
                            <span>Hotline: 0916 019 696</span>
                        </div>
                    </div>
                </div>

                <div className="title-wrap">
                    <h1>PHIẾU KHÁM CHỈNH NHA</h1>
                </div>


                <h2 className="section-title">I. THÔNG TIN KHÁCH HÀNG</h2>
                <table className="kv-table mb-4">
                    <tr>
                        <th>Họ và tên khách hàng</th>
                        <td><strong>{customer?.full_name}</strong></td>
                    </tr>
                    <tr>
                        <th>Mã khách hàng</th>
                        <td>{customer?.code}</td>
                    </tr>
                    <tr>
                        <th>Số CCCD/CMND</th>
                        <td>{customer?.identity_number}</td>
                    </tr>
                    <tr>
                        <th>Ngày sinh</th>
                        <td>{isValidDate(customer?.birthday, false)}</td>
                    </tr>
                    <tr>
                        <th>Tuổi</th>
                        <td>{customer?.age}</td>
                    </tr>
                    <tr>
                        <th>Địa chỉ</th>
                        <td>{address}</td>
                    </tr>
                </table>


                <h2 className="section-title">II. BĂN KHOĂN CỦA BỆNH NHÂN</h2>
                {ban_khoan_cua_benh_nhan && <div className="mb-2">{ban_khoan_cua_benh_nhan}</div>}

                <h2 className="section-title">III. KHÁM TRONG MIỆNG</h2>
                <div className="section-subtitle"><strong>1. Đánh giá tình trạng răng và cung răng</strong></div>
                {kich_thuoc_cung_rang && <div className="mb-2">• <strong>Kích thước cung răng:</strong> {kich_thuoc_cung_rang}</div>}
                {ham_tren_muc_do_chen_chuc && <div className="mb-2">• <strong>Hàm trên: Mức độ chen chúc ước tính:</strong> {ham_tren_muc_do_chen_chuc}</div>}
                {ham_duoi_muc_do_chen_chuc && <div className="mb-2">• <strong>Hàm dưới: Mức độ chen chúc ước tính:</strong> {ham_duoi_muc_do_chen_chuc}</div>}

                {khe_thua_ham_tren && <div className="mb-2">• <strong>Khe thưa hàm trên:</strong> {renderRank(khe_thua_ham_tren, '', false)}</div>}
                {khe_thua_ham_duoi && <div className="mb-2">• <strong>Khe thưa hàm dưới:</strong> {renderRank(khe_thua_ham_duoi, '', false)}</div>}
                {thua_thieu_rang && <div className="mb-2">• <strong>Bệnh nhân có thiếu/thừa răng không?:</strong> {renderRank(thua_thieu_rang, '', false)}</div>}

                {bat_thuong_rang_can_luu_y && <div className="mb-2">• <strong>Bệnh nhân có bất thường gì về kích thước / hình dáng / độ xoay lệch răng hoặc bất thường khác cần lưu ý khi chỉnh nha không? (Bác sĩ liệt kê): </strong> {bat_thuong_rang_can_luu_y}</div>}

                <div className="section-subtitle"><strong>2. Đánh giá tình trạng khớp cắn</strong></div>
                {do_trum && <div className="mb-2">• <strong>Độ trùm:</strong> {do_trum}</div>}
                {do_chia && <div className="mb-2">• <strong>Độ chìa:</strong> {do_chia}</div>}

                <div className="section-subtitle"><strong>Khớp cắn bên trái</strong></div>
                {rang_3_trai && <div className="mb-2">• <strong>Răng 3:</strong> {renderRank(rang_3_trai, 'mm', false)}</div>}
                {rang_6_trai && <div className="mb-2">• <strong>Răng 6:</strong> {renderRank(rang_6_trai, 'mm', false)}</div>}

                <div className="section-subtitle"><strong>Khớp cắn bên phải</strong></div>
                {rang_3_phai && <div className="mb-2">• <strong>Răng 3:</strong> {renderRank(rang_3_phai, 'mm', false)}</div>}
                {rang_6_phai && <div className="mb-2">• <strong>Răng 6:</strong> {renderRank(rang_6_phai, 'mm', false)}</div>}

                {duong_cong_spee && <div className="mb-2">• <strong>Đường cong spee:</strong> {duong_cong_spee}</div>}
                {mat_phang_can && <div className="mb-2">• <strong>Mặt phẳng cắn:</strong> {renderRank(mat_phang_can, '', false)}</div>}
                {loai_mo_nha_chu && <div className="mb-2">• <strong>Loại mô nha chu:</strong> {loai_mo_nha_chu}</div>}
                {can_lech_chuc_nang && <div className="mb-2">• <strong>Cắn lệch chức năng:</strong> {can_lech_chuc_nang}</div>}
                {khop_can_bat_thuong_can_luu_y && <div className="mb-2">• <strong>Bệnh nhân có bất thường gì về khớp cắn khác cần lưu ý khi chỉnh nha không? (Bác sĩ liệt kê): </strong> {khop_can_bat_thuong_can_luu_y}</div>}

                <div className="section-subtitle"><strong>3. Các ghi chú và quan sát khác</strong></div>
                {kich_thuoc_luoi && <div className="mb-2">• <strong>Kích thước lưỡi:</strong> {kich_thuoc_luoi}</div>}
                {tat_day_luoi && <div className="mb-2">• <strong>Tật đẩy lưỡi:</strong> {tat_day_luoi}</div>}
                {quan_sat_va_luu_y_khac_chinh_nha && <div className="mb-2">• <strong>Quan sát hoặc lưu ý khác của bác sĩ về bệnh nhân mà cần được cân nhắc trong quá trình chỉnh nha? (Bác sĩ liệt kê):</strong> {quan_sat_va_luu_y_khac_chinh_nha}</div>}

                <h2 className="section-title">IV. KHÁM NGOÀI MẶT</h2>
                <div className="section-subtitle"><strong>1. Đánh giá mặt thẳng ở tư thế nghỉ</strong></div>

                {dang_mat_thang && <div className="mb-2">• <strong>Dạng mặt thẳng:</strong> {dang_mat_thang}</div>}
                {do_can_doi_cam && <div className="mb-2">• <strong>Độ cân đối của cằm:</strong> {do_can_doi_cam} </div>}
                {tuong_quan_tang_mat_duoi && <div className="mb-2">• <strong>Tương quan tầng mặt dưới so với tổng thể khuôn mặt:</strong> {tuong_quan_tang_mat_duoi}</div>}
                {moi_khep_nghi && <div className="mb-2">• <strong>Môi có khép kín ở tư thế nghỉ hay không:</strong> {moi_khep_nghi} </div>}
                {ranh_moi_cam && <div className="mb-2">• <strong>Rãnh môi cằm:</strong> {ranh_moi_cam}</div>}
                {bat_thuong_mat_thang_nghi && <div className="mb-2">• <strong>Ngoài ra có bất thường gì nổi trội khác hay không?</strong> {bat_thuong_mat_thang_nghi} </div>}

                <div className="section-subtitle"><strong>2. Đánh giá mặt thẳng ở tư thế cười</strong></div>
                {duong_cuoi && <div className="mb-2">• <strong>Đường cười:</strong> {duong_cuoi}</div>}
                {cuoi_lo_nuou && <div className="mb-2">• <strong>Cười lộ nướu:</strong> {renderRank(cuoi_lo_nuou, 'mm', false)} </div>}
                {hanh_lang_ma && <div className="mb-2">• <strong>Hành lang má:</strong> {hanh_lang_ma}</div>}
                {duong_giua && <div className="mb-2">• <strong>Đường giữa:</strong> {renderRank(duong_giua, 'mm', false)} </div>}
                {bat_thuong_mat_thang_cuoi && <div className="mb-2">• <strong>Ngoài ra có bất thường gì nổi trội khác hay không?</strong> {bat_thuong_mat_thang_cuoi}</div>}

                <div className="section-subtitle"><strong>3. Đánh giá mặt nghiêng ở tư thế nghỉ</strong></div>
                {dang_mat_nghieng && <div className="mb-2">• <strong>Dạng mặt nghiêng:</strong> {dang_mat_nghieng}</div>}
                {goc_moi_tren && <div className="mb-2">• <strong>Góc môi trên:</strong> {goc_moi_tren} </div>}
                {vi_tri_cam && <div className="mb-2">• <strong>Vị trí cằm:</strong> {vi_tri_cam}</div>}
                {goc_mat_phang_ham_duoi && <div className="mb-2">• <strong>Góc mặt phẳng hàm dưới:</strong> {goc_mat_phang_ham_duoi} </div>}
                {lom_moi_cam && <div className="mb-2">• <strong>Lõm môi cằm:</strong> {lom_moi_cam}</div>}
                {hinh_thai_moi && <div className="mb-2">• <strong>Hình thái môi:</strong> {hinh_thai_moi}</div>}


                <h2 className="section-title">V. HƯỚNG ĐIỀU TRỊ SƠ BỘ</h2>
                <div className="mb-2">{huong_dieu_tri_so_bo}</div>

                <div className="print-date">
                    .............., ngày {formatVietnameseDate(created_at)}
                </div>


                <div className="signature-section mt-4">
                    <div className="sig-box">
                        <strong>Bác sĩ</strong>
                        <span className="note">(Ký, ghi rõ họ tên)</span>
                        <div className="sig-space"></div>
                        <div className="sig-name">{doctor}</div>
                    </div>

                    <div className="sig-box">
                        <strong>Khách hàng</strong>
                        <span className="note">(Ký, ghi rõ họ tên)</span>
                        <div className="sig-space"></div>
                        <div className="sig-name">{customer?.full_name}</div>
                    </div>
                </div>

                <style>
                    {`
                        /* --- Print & Page setup --- */
                        @page {
                            size: A4;
                            margin: 1cm 1.5cm 1.8cm 1.8cm;
                            /* top right bottom left */
                        }

                        :root {
                            --text: #111;
                            --muted: #666;
                            --border: #ddd;
                            --heading: #000;
                            --primary: #0b2b33;
                        }

                        @media print {
                            .no-print {
                                display: none !important;
                            }

                            .page-break {
                                page-break-before: always;
                            }

                            body {
                                font-family: "Times New Roman", serif;
                                font-size: 12pt;
                                line-height: 1.5;
                                color: #000;
                               /*  width: 210mm;
                                border: 1px solid #dedede; */
                            }
                        }

                        .container {
                            max-width: 800px;
                            margin: 0 auto;
                            padding: 0px;
                            position: relative;
                        }

                        .print-content h1,
                        .print-content h2,
                        .print-content h3 {
                            margin: 0 0 10px 0;
                            color: var(--heading);
                        }

                        .print-content h1 {
                            text-align: center;
                            font-size: 18pt;
                            letter-spacing: 0.3px;
                        }

                        .print-content h2.section-title {
                            font-size: 13.5pt;
                            /* border-left: 4px solid var(--primary);
                            padding-left: 8px; */
                            margin: 18px 0 10px 0;
                        }

                        .print-content .line-height-20{
                            line-height: 20px;
                        }
                        .subtitle {
                            color: var(--muted);
                            font-style: italic;
                            font-weight: normal;
                            margin-left: 6px;
                            font-size: 11.5pt;
                        }

                        /* --- Header --- */
                    .header {
                        display: flex;
                        align-items: flex-start;
                        justify-content: space-between;
                        margin-bottom: 20px;
                        border-bottom: 1px solid var(--border);
                        padding-bottom: 20px;
                        position: relative;
                    }

                    /* Nhóm bên phải (QR + thông tin) */
                    .header .footer {
                        display: flex;
                        align-items: flex-start;
                        gap: 16px;
                        border: none;
                        padding-top: 0;
                        margin-top: 0;
                    }

                    /* Logo */
                    .logo-box {
                        width: 90px;
                        height: 90px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;
                    }

                    .logo-box img {
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: contain;
                    }

                    /* QR */
                    .header .footer .qr-box {
                        width: 80px;
                        height: 80px;
                        flex-shrink: 0;
                    }

                    .header .footer .qr-box img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                        border: 1px solid var(--border);
                        background: #fff;
                        padding: 4px;
                    }

                    /* Clinic info */
                    .header .footer .clinic {
                        text-align: left;
                        margin-left: 8px;
                        font-size: 10.5pt;
                        line-height: 1.4;
                    }

                    .header .footer .clinic .section-title {
                        font-weight: bold;
                        color: var(--primary);
                        margin-bottom: 4px;
                        font-size: 11pt;
                    }

                    .header .footer .clinic span {
                        display: block;
                        font-size: 8px;
                        color: var(--muted);
                        line-height: 1.3;
                    }
                        .title-wrap {
                            margin: 8px 0 16px 0;
                        }

                        /* --- Tables --- */
                        table {
                            border-collapse: collapse;
                            width: 100%;
                        }

                        .kv-table td,
                        .kv-table th {
                            border: 0px solid var(--border);
                            padding: 5px 0px;
                            vertical-align: top;
                        }

                        .kv-table th {
                            width: 32%;
                            /* background: #fafafa; */
                            text-align: left;
                            font-weight: 600;
                        }

                        .grid-table th,
                        .grid-table td {
                            border: 1px solid var(--border);
                            padding: 6px 8px;
                            vertical-align: top;
                        }

                        .grid-table th {
                            background: #fafafa;
                        }

                        .narrow td,
                        .narrow th {
                            padding: 5px 6px;
                        }

                        .muted {
                            color: var(--muted);
                        }

                        /* --- Helpers --- */
                        .mb-4 {
                            margin-bottom: 16px;
                        }

                        .mb-2 {
                            margin-bottom: 8px;
                        }

                        .mt-2 {
                            margin-top: 8px;
                        }

                        .mt-4 {
                            margin-top: 16px;
                        }

                        .pt-2 {
                            padding-top: 8px;
                        }

                        .pt-4 {
                            padding-top: 16px;
                        }

                        .pl-2 {
                            padding-left: 8px;
                        }

                        .pl-4 {
                            padding-left: 16px;
                        }

                        .pr-2 {
                            padding-right: 8px;
                        }

                        .pr-4 {
                            padding-right: 16px;
                        }

                        .italic {
                            font-style: italic;
                        }

                        .center {
                            text-align: center;
                        }

                        .right {
                            text-align: right;
                        }

                        .checkbox {
                            font-family: "Segoe UI Symbol", "DejaVu Sans", "Times New Roman";
                        }

                        .note {
                            color: var(--muted);
                        }

                        .image-strip {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 8px;
                            border: 1px dashed var(--border);
                            padding: 10px;
                            min-height: 48px;
                        }

                        .image-thumb {
                            width: 110px;
                            height: 85px;
                            border: 1px solid var(--border);
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 10pt;
                            color: var(--muted);
                            background: #fff;
                        }

                        /* --- Textareas-like blocks --- */
                        .textblock {
                            min-height: 64px;
                            border: 1px solid var(--border);
                            padding: 8px;
                            white-space: pre-wrap;
                        }

                        .textblock.tall {
                            min-height: 96px;
                        }

                        .disease-grid {
                            display: flex;
                            gap: 16px;
                            justify-content: space-between;
                        }

                        .disease-column {
                            flex: 1;
                        }

                        .disease-column table {
                            width: 100%;
                        }

                        .disease-column td strong {
                            margin-right: 4px;
                            color: var(--primary);
                        }

                        @media print {
                            .disease-grid {
                                page-break-inside: avoid;
                            }
                        }

                        .bite-item {
                            justify-content: space-between;
                            padding: 6px 0;
                        }

                        .bite-item:last-child {
                            border-bottom: none;
                        }

                        .bite-label {
                            flex: 1;
                            color: var(--text);
                        }

                        .bite-value {
                            min-width: 60px;
                            text-align: right;
                            font-weight: bold;
                            color: var(--primary);
                        }

                        .section-subtitle {
                            font-size: 12.5pt;
                            margin-bottom: 6px;
                        }

                        .print-date {
                            text-align: right;
                            margin-top: 40px;
                            font-size: 12pt;
                            font-style: italic;
                            color: var(--text);
                        }

                        .signature-section {
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-start;
                            margin-top: 30px;
                            text-align: center;
                            gap: 60px;
                            margin-bottom: 50px;
                        }

                        .sig-box {
                            flex: 1;
                        }

                        .sig-box strong {
                            font-size: 13pt;
                            display: block;
                            margin-bottom: 2px;
                        }

                        .sig-box .note {
                            color: var(--muted);
                            font-style: italic;
                            font-size: 11pt;
                        }

                        .sig-space {
                            height: 60px;
                            margin: 24px auto 8px auto;
                            width: 80%;
                        }

                        .sig-name {
                            font-weight: bold;
                            font-size: 12pt;
                            color: var(--primary);
                            text-transform: uppercase;
                        }
                    `}
                </style>
            </div >
        );
    }
}

export default PrintOrthodonticExam;
